export class FuellingProvider {
    id: number;
    supplierId: number;
	fuellingProviderType: string;
    providerParameters: Map<String, String>;
	deleted : string
}
